import CustomLogout from './custom-logout.component';

export default CustomLogout;
